import { render, staticRenderFns } from "./OrdersListTable.vue?vue&type=template&id=b7288a72&scoped=true"
import script from "./OrdersListTable.vue?vue&type=script&lang=js"
export * from "./OrdersListTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersListTable.vue?vue&type=style&index=0&id=b7288a72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7288a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7288a72')) {
      api.createRecord('b7288a72', component.options)
    } else {
      api.reload('b7288a72', component.options)
    }
    module.hot.accept("./OrdersListTable.vue?vue&type=template&id=b7288a72&scoped=true", function () {
      api.rerender('b7288a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformOrderManagement/components/OrdersListTable.vue"
export default component.exports